import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c5a0a14a")

_pushScopeId("data-v-c5a0a14a")
const _hoisted_1 = { class: "membership" }
const _hoisted_2 = { class: "content_ls_margin" }
const _hoisted_3 = { class: "ls-slate-dark" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", null, "Current Committee Membership", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("h4", null, "Serving on a Law Society Committee is a significant time commitment. While we provide the option to list preferences for up to three committees, we note that many applicants only wish to serve on one committee. Please indicate whether you have the capacity to serve on more than one committee. *", -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  class: "col-6 ml-0",
  style: {"min-width":"100px"}
}
const _hoisted_14 = { class: "radio outline" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { for: "radioPage3_0" }, "Yes", -1)
const _hoisted_16 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, " Mandatory field", -1)
const _hoisted_19 = {
  class: "col-6 ml-0",
  style: {"min-width":"100px"}
}
const _hoisted_20 = { class: "radio outline" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "radioPage3_1" }, "No", -1)
const _hoisted_22 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, " Mandatory field", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "select" }
const _hoisted_28 = /*#__PURE__*/_createVNode("option", {
  selected: "",
  disabled: "",
  value: ""
}, "- Select committee 1 -", -1)
const _hoisted_29 = {
  key: 0,
  class: "validation-msg ma-1"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "fal fa-exclamation-circle" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Mandatory field ")
const _hoisted_32 = /*#__PURE__*/_createVNode("div", {
  style: {"clear":"both"},
  class: "mb-2"
}, null, -1)
const _hoisted_33 = { class: "select" }
const _hoisted_34 = /*#__PURE__*/_createVNode("option", {
  selected: "",
  value: ""
}, "- Select committee 2 -", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", {
  style: {"clear":"both"},
  class: "mb-2"
}, null, -1)
const _hoisted_36 = { class: "select" }
const _hoisted_37 = /*#__PURE__*/_createVNode("option", {
  selected: "",
  value: ""
}, "- Select committee 3 -", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { style: {"clear":"both"} }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.pageHeader), 1),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      (_ctx.myCommittees && _ctx.myCommittees.length > 0)
        ? (_openBlock(), _createBlock("section", _hoisted_7, [
            _hoisted_8,
            _createVNode("ol", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.myCommittees, (mc) => {
                return (_openBlock(), _createBlock("li", null, [
                  _createVNode("p", null, _toDisplayString(mc.name), 1)
                ]))
              }), 256))
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_9,
      _createVNode("h3", null, "Membership Committee " + _toDisplayString(_ctx.committeeYear), 1),
      _hoisted_10,
      _hoisted_11,
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _withDirectives(_createVNode("input", {
              type: "radio",
              name: "radioPage3",
              id: "radioPage3_0",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.eoi.isSingleCommitteeOnly = $event)),
              value: false,
              onChange: _cache[2] || (_cache[2] = $event => (_ctx.mandatoryCheck()))
            }, null, 544), [
              [_vModelRadio, _ctx.eoi.isSingleCommitteeOnly]
            ]),
            _hoisted_15
          ]),
          (_ctx.eoi.isSingleCommitteeOnly == null)
            ? (_openBlock(), _createBlock("span", _hoisted_16, [
                _hoisted_17,
                _hoisted_18
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _withDirectives(_createVNode("input", {
              type: "radio",
              name: "radioPage3",
              id: "radioPage3_1",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.eoi.isSingleCommitteeOnly = $event)),
              value: true,
              onChange: _cache[4] || (_cache[4] = $event => (_ctx.mandatoryCheck()))
            }, null, 544), [
              [_vModelRadio, _ctx.eoi.isSingleCommitteeOnly]
            ]),
            _hoisted_21
          ]),
          (_ctx.eoi.isSingleCommitteeOnly == null)
            ? (_openBlock(), _createBlock("span", _hoisted_22, [
                _hoisted_23,
                _hoisted_24
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_25,
      (_ctx.committeeList.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_26, [
            _createVNode("h4", null, "Which " + _toDisplayString(_ctx.committeeYear) + " committee would you like to apply for as your first selection? *", 1),
            _createVNode("div", _hoisted_27, [
              _withDirectives(_createVNode("select", {
                onChange: _cache[5] || (_cache[5] = $event => (_ctx.resetCommitteeList())),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.selectedCommittee0 = $event)),
                id: "selectedCommittee0",
                class: _ctx.selectedCommittee0 == '' ? 'placeholder' : ''
              }, [
                _hoisted_28,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.committeeList, (c) => {
                  return (_openBlock(), _createBlock("option", {
                    value: {id: c.id, name: c.name},
                    hidden: c.disabled,
                    disabled: c.disabled
                  }, _toDisplayString(c.name), 9, ["value", "hidden", "disabled"]))
                }), 256))
              ], 34), [
                [
                  _vModelSelect,
                  _ctx.selectedCommittee0,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.selectedCommittee0 === '')
                ? (_openBlock(), _createBlock("span", _hoisted_29, [
                    _hoisted_30,
                    _hoisted_31
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_32,
            _createVNode("h4", null, "Which " + _toDisplayString(_ctx.committeeYear) + " committee would you like to apply for as your second selection?", 1),
            _createVNode("div", _hoisted_33, [
              _withDirectives(_createVNode("select", {
                onChange: _cache[7] || (_cache[7] = $event => (_ctx.resetCommitteeList())),
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.selectedCommittee1 = $event)),
                id: "selectedCommittee1",
                class: _ctx.selectedCommittee1 == '' ? 'placeholder' : ''
              }, [
                _hoisted_34,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.committeeList, (c) => {
                  return (_openBlock(), _createBlock("option", {
                    value: {id: c.id, name: c.name},
                    hidden: c.disabled,
                    disabled: c.disabled
                  }, _toDisplayString(c.name), 9, ["value", "hidden", "disabled"]))
                }), 256))
              ], 34), [
                [
                  _vModelSelect,
                  _ctx.selectedCommittee1,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _hoisted_35,
            _createVNode("h4", null, "Which " + _toDisplayString(_ctx.committeeYear) + " committee would you like to apply for as your third selection?", 1),
            _createVNode("div", _hoisted_36, [
              _withDirectives(_createVNode("select", {
                onChange: _cache[9] || (_cache[9] = $event => (_ctx.resetCommitteeList())),
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.selectedCommittee2 = $event)),
                id: "selectedCommittee2",
                class: _ctx.selectedCommittee2 == '' ? 'placeholder' : ''
              }, [
                _hoisted_37,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.committeeList, (c) => {
                  return (_openBlock(), _createBlock("option", {
                    value: {id: c.id, name: c.name},
                    hidden: c.disabled,
                    disabled: c.disabled
                  }, _toDisplayString(c.name), 9, ["value", "hidden", "disabled"]))
                }), 256))
              ], 34), [
                [
                  _vModelSelect,
                  _ctx.selectedCommittee2,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_38
    ])
  ]))
})